module.exports = __webpack_public_path__ + "static/img/step1.a15ca61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step1.png
// module id = MMz/
// module chunks = 128